// extracted by mini-css-extract-plugin
module.exports = {"profile_btn":"ProfileIcon_profile_btn__Pd37O","animated_background":"ProfileIcon_animated_background__3osQB","profile_letter":"ProfileIcon_profile_letter__RGLUI"};